// src/utils/identity.js
export function getUserIdentity(user) {
  if (!user) return { id: "", label: "Unknown", provider: "unknown" };
  const id = user.uid || user.id || "";
  const email = user.email || null;
  const phone = user.phoneNumber || null;
  const label = phone ?? email ?? `uid:${id}`;
  const provider = phone ? "phone" : email ? "email" : "unknown";
  return { id, email, phone, label, provider };
}
